import { LogType } from './log-type';
import { CommonUtils } from '../../tool/common-utils';

export class Log {
  public date: Date;
  public type: LogType;
  public data: any[];

  public static getType(data: string | Error | object): LogType {
    if (data instanceof Error) {
      return LogType.error;
    }
    return LogType.verbose;
  }

  constructor(data: any[], type: LogType) {
    this.date = new Date();
    this.type = type;
    this.data = data;
  }

  public toString(): string {
    return `${CommonUtils.convertDateToTimeString(this.date, true)} [${this.type}]`;
  }

  console() {
    switch (this.type) {
      case LogType.error:
        console.error(this.toString(), ...this.data);
        break;
      case LogType.warning:
        console.warn(this.toString(), ...this.data);
        break;
      default:
        console.log(this.toString(), ...this.data);
    }
  }
}
